import React from 'react';
import cx from 'classnames';

import { Link } from 'gatsby';
import logoColor from '../../../static/logo-full-color.svg';

import styles from './index.module.scss';

import { setLocale } from '../../lib/localeStore';
import nav, { getNavItem } from '../../lib/nav';

const navItems = ['admissions', 'the-kingston-difference', 'learning-at-kingston', 'life-at-kingston'];

const parentPortalNavItem = nav.find(({ key }) => key === 'parent-portal');

const renderLinks = (locale, key, items, onClose) => (
  <ul>
    {items.map(item => (
      <li key={item.key}>
        {item.url ? (
          <a href={item.url} onClick={onClose}>
            {item.text[locale]}
          </a>
        ) : (
          <Link exact to={`/${locale}${item.uri}`} onClick={onClose}>
            {item.text[locale]}
          </Link>
        )}
      </li>
    ))}
  </ul>
);

const createChangeLocaleHandler = (currentLocale, locale) => e => {
  e.preventDefault();

  if (currentLocale === locale) {
    return;
  }

  setLocale(locale);

  const currentUrl = `${window.location}`;
  const url =
    currentUrl.indexOf(`/${currentLocale}/`) > -1
      ? currentUrl.replace(`/${currentLocale}/`, `/${locale}/`)
      : `/${locale}`;
  window.location = url;
};

/* eslint-disable react/prop-types */
export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasMounted: false };
  }

  componentDidMount() {
    this.setState({ hasMounted: true });
  }

  render() {
    const { locale = 'en', isActive, onClose } = this.props;

    return (
      <div
        className={cx({
          [styles.root]: true,
          [styles.active]: isActive,
        })}
      >
        <Link to="/" className={styles.logo} onClick={onClose}>
          <img src={logoColor} alt="Kingston International School" />
        </Link>

        <div className={styles.locale}>
          <ul key={this.state.hasMounted ? 'mounted' : 'not-mounted'}>
            <li>
              <a
                href="/en"
                className={locale === 'en' ? styles.selected : ''}
                onClick={createChangeLocaleHandler(locale, 'en')}
              >
                EN
              </a>
            </li>
            <li>
              <a
                href="/zh"
                className={locale === 'zh' ? styles.selected : ''}
                onClick={createChangeLocaleHandler(locale, 'zh')}
              >
                中文
              </a>
            </li>
          </ul>
        </div>

        <div className={styles.nav}>
          {navItems.map(key => nav.find(m => m.key === key)).map(({ text, key, items }) => (
            <section key={key}>
              <h5 className={styles.title}>{text[locale]}</h5>
              {renderLinks(locale, key, items, onClose)}
            </section>
          ))}
          <section>
            <Link exact to={`/${locale}${getNavItem('contact-us').uri}`}>
              {getNavItem('contact-us').text[locale]}
            </Link>
          </section>
          <section>
            <a href={parentPortalNavItem.url} target="_blank" rel="noopener noreferrer">
              {parentPortalNavItem.text[locale]}
            </a>
          </section>
        </div>

        {isActive && <div className={styles.navToggle} onClick={onClose} />}
      </div>
    );
  }
}
